angular.module('webcomm')
    .directive('urlMessage', ['$log', function($log) {
        function link(scope, element, attrs) {
            var newMessage = '';

            if (scope.urls) {
                let si = 0;
                let value = '';
                for (let url of scope.urls) {
                    if (!url.value.startsWith('http'))
                        value = 'http://' + url.value;
                    else 
                        value = url.value;

                    if(url.index > 0)
                        newMessage += `${scope.message.slice(si, url.index - 1)} <a target="_blank" href="${value}">${url.value}</a>`;
                    else
                        newMessage += `<a target="_blank" href="${value}">${url.value}</a>`;

                    si = url.index + url.value.length;
                }
                newMessage += scope.message.substring(si);
            } else
                newMessage = scope.message;

            element.html(newMessage);
        }

        return {
            restrict: 'A',
            scope: {
                urls: '=',
                message: '='
            },
            link: link
        };
    }]);